import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { ClassTypesWidget } from './ClassTypesWidget'

class HoldstyringClassTypesElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return ClassTypesWidget
  }

  // Supported HTML attributes:
  //   title="Vores hold"            — heading above the cards (default: none)
  //   max-items="6"                 — show only first N class types
  //   show-benefits="false"         — hide benefits checklist (default: visible)
  //   show-meta="false"             — hide duration/level/max-participants (default: visible)
  //   hold-type-slugs="yoga,pilates" — only show templates tagged with these hold-mærkater
  protected getWidgetProps() {
    const raw = this.getAttribute('max-items')
    const slugsRaw = this.getAttribute('hold-type-slugs') || ''
    const holdTypeSlugs = slugsRaw.split(',').map(s => s.trim()).filter(Boolean)
    return {
      title: this.getAttribute('title') || null,
      maxItems: raw && /^\d+$/.test(raw) ? parseInt(raw, 10) : null,
      showBenefits: this.getAttribute('show-benefits') !== 'false',
      showMeta: this.getAttribute('show-meta') !== 'false',
      holdTypeSlugs,
    }
  }
}

if (!customElements.get('holdstyring-class-types')) {
  customElements.define('holdstyring-class-types', HoldstyringClassTypesElement)
}

export { HoldstyringClassTypesElement }
